import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Home, LocalDining, DeliveryDining, Search } from "@mui/icons-material";
import WSIconCard from "../../Components/IconCard/WSIconCard";
import { WSIcons } from "../../commonFunctions/iIcons";
import RightSidebarEzee from "./Others";
import Footer from "./Footer";
import Others from "./Others";
import path from "path";
import { useNavigate } from "react-router-dom";
import SearchNoCharge from "../NoCharge/Search";
import { OrderInformation } from "../AdvanceOrder/OrderInformation";
import { DayClose } from "../DayClose/DayClose";

const MainContent: React.FC = () => {
  const navigate = useNavigate()
  const [openSearch,setOpenSearch] = useState(false)
  const [openOrderInformation,setOpenOrderInformation] = useState(false)
  const [openDayClose,setOpenDayClose] = useState(false)

  const handleClick = (path: string)=>{
    navigate(path)
  }

  const handleNoChargeClick=()=>{
    setOpenSearch(true)
  }

  const handleNoChargeClose = ()=>{
    setOpenSearch(false)
  }
  /**
   * Advance Order- Order information Dialogue 
   */
  const handleAdvanceOrderClick=()=>{
    setOpenOrderInformation(true)
  }

  const handleAdvanceOrderClose = ()=>{
    setOpenOrderInformation(false)
  }

   /**
   * Day Close
   */
   const handleDayCloseClick=()=>{
    setOpenDayClose(true)
  }

  const handleDayCloseClose = ()=>{
    setOpenDayClose(false)
  }
  return (
    <Grid container spacing={2}>
    <Grid   xs={12} sm={10} sx={{ padding: "2rem" }}>
      {/* Order Type Section */}
      <Typography variant="h5" sx={{ marginBottom: "16px",color: 'green' }}>
        Order Type
      </Typography>
      <Grid container spacing={2} padding={2}>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.RestaurantMenuIcon
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="Dine In"
            onClick={()=>handleClick('/dinein')}

          />
        </Grid>
        <Grid item>
          <WSIconCard
          onClick={()=>handleClick('/takeaway')}
            icon={
              <WSIcons.TakeoutDiningIcon
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="Take Away"
          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.DeliveryDiningIcon
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="Delivery"
            onClick={()=>handleClick('/delivery')}
          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.RoomServiceIcon
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="Catering"
            onClick={()=>handleClick('/catering')}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.CardGiftcardIcon
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="No Charge"
            onClick={handleNoChargeClick}
          />
        </Grid>
        <SearchNoCharge open={openSearch} onClose={handleNoChargeClose}/>
        <Grid item>
          <WSIconCard
            icon={<WSIcons.AlarmIcon sx={{ fontSize: "2rem", marginTop: 2 }} />}
            name="Advance Order"
            onClick={handleAdvanceOrderClick}
          />
        </Grid>
        <OrderInformation open={openOrderInformation} onClose={handleAdvanceOrderClose}/>
      </Grid>

      {/* Transaction Section */}
      <Typography variant="h5" sx={{ marginTop: "32px", marginBottom: "16px",color: 'green' }}>
        Transaction
      </Typography>
      <Grid container spacing={2} padding={2}>
        
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.ReceiptLongIcon
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="Receipt"
            onClick={()=>handleClick("/receiptlist")}
          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.PendingIcon sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Hold Item"
            onClick={()=>handleClick("/holditem")}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.Pendingreceipt sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Hold Receipt"
          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.HeadsetMicIcon sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Call Center"
            onClick={()=>handleClick("/callcenter")}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.AdvanceList sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Advance List"
            onClick={()=>handleClick("/advancelist")}

          />
        </Grid>
      </Grid>
      {/* Driver Routing Section */}

      <Grid sx={{ display: 'flex', alignItems: 'center', marginTop: "32px", marginBottom: "16px" }}>
  <Typography variant="h5" color={"green"}>
    Driver Routing
  </Typography>
  <Grid sx={{ flexGrow: 1, textAlign: 'center' }}>
    <Typography variant="h5" color={"green"}>
      Operation
    </Typography>
  </Grid>
</Grid>
      <Grid container spacing={2} padding={2}>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.NewTrip sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="New Trip"
            onClick={()=>handleClick("/newtrip")}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.checkin
                sx={{ fontSize: "2rem", marginTop: 2 }}
              />
            }
            name="Check In"
            onClick={()=>handleClick("/checkin")}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.Status sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Status"
            onClick={()=>handleClick("/status")}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.Report sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Report"
            onClick={()=>handleClick("/report")}

          />
        </Grid>
        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.Closecalender sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Day Close"
            onClick={handleDayCloseClick}
          />
        </Grid>
        <DayClose open={openDayClose} onClose={handleDayCloseClose}/>

        <Grid item>
          <WSIconCard
            icon={
              <WSIcons.MessageIcon sx={{ fontSize: "2rem", marginTop: 2 }} />
            }
            name="Message"
            onClick={()=>handleClick("/message")}

          />
        </Grid>
      </Grid>
    </Grid>
    <Grid item sm={2}>
<Others/>
    </Grid>
    <Grid  xs={12}>
        <Footer />
        </Grid>
    </Grid>
  );
};

export default MainContent;
